export const getImageDimensions = async (
  imageDataUrl: string,
): Promise<{ width: number; height: number }> => {
  const image = new Image();
  return new Promise((resolve, reject) => {
    image.src = imageDataUrl;

    image.onload = () => {
      resolve({ width: image.width, height: image.height });
    };

    image.onerror = reject;
  });
};
